/** Count panels in overlay/page panelRows grid. */
export function countPanelsInRows(panelRows: unknown): number {
  if (!Array.isArray(panelRows)) return 0
  let count = 0
  for (const row of panelRows) {
    if (!Array.isArray(row)) continue
    for (const cell of row) {
      if (cell && !cell._isRowspanPlaceholder && cell.panelId) {
        count += 1
      }
    }
  }
  return count
}

/** True when floating overlay has one pGroup panel (Swing JJCollapsePanel as sole chrome). */
export function isSinglePGroupOverlay(panelRows: unknown): boolean {
  if (!Array.isArray(panelRows)) return false
  let count = 0
  let pGroup = false
  for (const row of panelRows) {
    if (!Array.isArray(row)) continue
    for (const cell of row) {
      if (!cell || cell._isRowspanPlaceholder || !cell.panelId) continue
      count += 1
      if (String(cell._attributes?.style ?? '') === 'pGroup') {
        pGroup = true
      }
    }
  }
  return count === 1 && pGroup
}
